import { render } from "./MiSkeleton.vue?vue&type=template&id=f10d6aca&scoped=true"
import script from "./MiSkeleton.vue?vue&type=script&lang=js"
export * from "./MiSkeleton.vue?vue&type=script&lang=js"

import "./MiSkeleton.vue?vue&type=style&index=0&id=f10d6aca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10d6aca"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
